import { generateKeys, generateLocalization } from '../utils';
export const surveyTypes = generateKeys({
    customerSatisfaction: {
        value: 'customer_satisfaction',
        label: 'Customer Satisfaction',
    },
});
export const surveyAnswers = generateLocalization('surveyAnswers', generateKeys({
    yes: {
        label: 'Yes',
        value: 100,
        questionType: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    no: {
        label: 'No',
        value: 20,
        questionType: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    stronglyAgree: {
        label: 'Strongly agree',
        value: 100,
        questionType: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    agree: {
        label: 'Agree',
        value: 80,
        questionType: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    neitherAgreeNorDisagree: {
        label: 'Neither Agree nor Disagree',
        value: 60,
        questionType: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    disagree: {
        label: 'Disagree',
        value: 40,
        questionType: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    stronglyDisagree: {
        label: 'Strongly Disagree',
        value: 20,
        questionType: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    rating1: {
        label: '1',
        value: 10,
        questionType: 'rating10',
        localization: { id: '', defaultMessage: '' },
    },
    rating2: {
        label: '2',
        value: 20,
        questionType: 'rating10',
        localization: { id: '', defaultMessage: '' },
    },
    rating3: {
        label: '3',
        value: 30,
        questionType: 'rating10',
        localization: { id: '', defaultMessage: '' },
    },
    rating4: {
        label: '4',
        value: 40,
        questionType: 'rating10',
        localization: { id: '', defaultMessage: '' },
    },
    rating5: {
        label: '5',
        value: 50,
        questionType: 'rating10',
        localization: { id: '', defaultMessage: '' },
    },
    rating6: {
        label: '6',
        value: 60,
        questionType: 'rating10',
        localization: { id: '', defaultMessage: '' },
    },
    rating7: {
        label: '7',
        value: 70,
        questionType: 'rating10',
        localization: { id: '', defaultMessage: '' },
    },
    rating8: {
        label: '8',
        value: 80,
        questionType: 'rating10',
        localization: { id: '', defaultMessage: '' },
    },
    rating9: {
        label: '9',
        value: 90,
        questionType: 'rating10',
        localization: { id: '', defaultMessage: '' },
    },
    rating10: {
        label: '10',
        value: 100,
        questionType: 'rating10',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const customerSatisfactionSurveyQuestions = generateLocalization('customerSatisfactionSurveyQuestions', generateKeys({
    tradingConditions: {
        label: 'What do you think about our trading conditions?',
        type: 'sectionTitle',
        localization: { id: '', defaultMessage: '' },
    },
    conditionsOffered: {
        label: 'I am happy with the trading conditions offered.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    tradingExperience: {
        label: 'My trading experience is always seamless.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    easilyFindTradingInstruments: {
        label: 'I can easily find the instruments I wish to trade on the chosen platform.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    varietyOIfTradingInstruments: {
        label: 'I am satisfied with the variety of the trading instruments offered.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    speedOfTradeExecution: {
        label: 'I am happy with the speed of trade execution.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    tradingToolsOffered: {
        label: 'What is your opinion on the trading tools offered?',
        type: 'sectionTitle',
        localization: { id: '', defaultMessage: '' },
    },
    tradingProductsOffered: {
        label: 'I am satisfied with the trading products offered.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    toolsToMakeDecisions: {
        label: 'I use the available tools to help me make decisions on what to trade.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    autochartistTools: {
        label: 'I prefer to trade using Autochartist tools.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    tradingCentralTools: {
        label: 'I find Trading Central tools more helpful when making trading decisions.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    autochartistBetterThanTradingCentral: {
        label: 'I find Autochartist tools more user friendly than Trading Central tools.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    educationalAgreementLevel: {
        label: 'What is your agreement level with the following statements?',
        type: 'sectionTitle',
        localization: { id: '', defaultMessage: '' },
    },
    educationalResourcesAvailable: {
        label: 'I am satisfied with the educational resources available to me.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    wellStructuredWebinars: {
        label: 'Webinars are well structured and provide the necessary information.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    moreEBooksAvailable: {
        label: 'I believe I would benefit from having more eBooks available.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    moreSeminarsOrganized: {
        label: 'I would like to see more seminars organized.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    accountTypesOffered: {
        label: 'What is your opinion on the account types offered?',
        type: 'sectionTitle',
        localization: { id: '', defaultMessage: '' },
    },
    varietyOfAccountTypes: {
        label: 'I am happy with the variety of the account types offered.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    tailoredAccountTypes: {
        label: 'I believe the account types are tailored to different client needs.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    accountFeatures: {
        label: 'The account features offered are attractive and competitive.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    leverageOffered: {
        label: 'I am satisfied with the leverage offered.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    paymentsAgreementLevel: {
        label: 'What is your agreement level with the following statements?',
        type: 'sectionTitle',
        localization: { id: '', defaultMessage: '' },
    },
    depositsProcessedFast: {
        label: 'My deposits have always been processed fast and with no issues.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    paymentOptionsAvailable: {
        label: 'I am happy with the payment options available to me for deposits.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    withdrawalsTime: {
        label: 'I am satisfied with the time needed to process my withdrawals.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    easyDepositsWithdrawals: {
        label: 'I find it easy to make a deposit or submit a withdrawal.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    accountOppening: {
        label: 'Opening an account with BDSwiss is easy and fast.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    accountVerificationInstructions: {
        label: 'I have received clear instructions for account verification.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    fastAccountVerification: {
        label: 'My account(s) are verified in a timely manner.',
        type: 'agreementRating',
        localization: { id: '', defaultMessage: '' },
    },
    doYouHaveAccountManager: {
        label: 'Do you have an account manager?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
        isSectionHeader: true,
    },
    accountManagerRating: {
        label: 'Please rate your account manager',
        type: 'sectionTitle',
        relation: { key: 'doYouHaveAccountManager', value: surveyAnswers.yes.value },
        localization: { id: '', defaultMessage: '' },
    },
    satisfiedWithTraining: {
        label: 'I am satisfied with the training and support I have received.',
        type: 'agreementRating',
        relation: { key: 'doYouHaveAccountManager', value: surveyAnswers.yes.value },
        localization: { id: '', defaultMessage: '' },
    },
    knowledgeableAgents: {
        label: 'I believe BDSwiss agents are knowledgeable of the products offered.',
        type: 'agreementRating',
        relation: { key: 'doYouHaveAccountManager', value: surveyAnswers.yes.value },
        localization: { id: '', defaultMessage: '' },
    },
    suggestImprovements: {
        label: 'What would you improve based on your experience with BDSwiss services?',
        type: 'text',
        localization: { id: '', defaultMessage: '' },
        isSectionHeader: true,
    },
    suggestProductsOrTools: {
        label: 'Are there any new products or tools that you would like to see at BDSwiss?',
        type: 'text',
        localization: { id: '', defaultMessage: '' },
        isSectionHeader: true,
    },
    recommendToFriends: {
        label: 'How likely are you to recommend BDSwiss to your friends? (1 not at all likely, 10 extremely likely)',
        type: 'rating10',
        localization: { id: '', defaultMessage: '' },
        isSectionHeader: true,
    },
    otherQuestions: {
        label: 'Do you have any other comments, questions, or concerns?',
        type: 'text',
        localization: { id: '', defaultMessage: '' },
        isSectionHeader: true,
    },
}));
export const customerSatisfactionSurveyFeedback = generateLocalization('customerSatisfactionSurveyFeedback', generateKeys({
    agreementRatingComment: {
        label: 'Tell us a little bit more',
        localization: { id: '', defaultMessage: '' },
    },
}));
